import React from 'react';
import { Dialog } from '@mui/material';
import ConfirmWithMessageContent from './ConfirmWithMessageContent';
import './ConfirmDialog.scss';

const ConfirmDialog = ({
    title = null,
    header = null,
    showTextField = true,
    open,
    onCancel,
    onConfirm,
    children,
}) => (
    <Dialog
        className="confirm-approval-dialog"
        open={open}
    >
        <ConfirmWithMessageContent
            title={title}
            header={header}
            showTextField={showTextField}
            translation="employee"
            onCancel={onCancel}
            onConfirm={onConfirm}
        >
            {children}
        </ConfirmWithMessageContent>
    </Dialog>
);


export default ConfirmDialog;
